export default {"src":"/_next/static/media/congratulations.5cba297f.svg","height":479,"width":393,"blurWidth":0,"blurHeight":0};